import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import {
  OrdersSchoolTypes,
  OrderInterface,
  ChargeRequestInterface,
} from './types';

// Get Order
export const getOrderSchoolRequest = (payload: object) =>
  action(OrdersSchoolTypes.GET_ORDER_SCHOOL_REQUEST, payload);
export const getOrderSchoolSuccess = (payload: {
  chargeRequestSchoolData: ChargeRequestInterface;
}) => action(OrdersSchoolTypes.GET_ORDER_SCHOOL_SUCCESS, payload);
export const getOrderSchoolFailure = () =>
  action(OrdersSchoolTypes.GET_ORDER_SCHOOL_FAILURE);

// List Orders
export const listOrdersSchoolRequest = (payload: object) =>
  action(OrdersSchoolTypes.LIST_ORDERS_SCHOOL_REQUEST, payload);
export const listOrdersSchoolSuccess = (payload: {
  chargeRequestSchoolList: ChargeRequestInterface[];
  totalCount: number;
}) => action(OrdersSchoolTypes.LIST_ORDERS_SCHOOL_SUCCESS, payload);
export const listOrdersSchoolFailure = () =>
  action(OrdersSchoolTypes.LIST_ORDERS_SCHOOL_FAILURE);

// Create Order
export const createOrderSchoolRequest = (payload: OrderInterface) =>
  asyncAction(OrdersSchoolTypes.CREATE_ORDER_SCHOOL_REQUEST, payload);
export const createOrderSchoolSuccess = (payload: {
  chargeRequestSchoolData: ChargeRequestInterface;
}) => action(OrdersSchoolTypes.CREATE_ORDER_SCHOOL_SUCCESS, payload);
export const createOrderSchoolFailure = () =>
  action(OrdersSchoolTypes.CREATE_ORDER_SCHOOL_FAILURE);

// Repeat Order
export const repeatOrderSchoolRequest = (payload: object) =>
  action(OrdersSchoolTypes.CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_REQUEST, payload);
export const repeatOrderSchoolSuccess = (payload: {
  chargeRequestRepeatSchoolData: ChargeRequestInterface;
}) =>
  action(OrdersSchoolTypes.CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_SUCCESS, payload);
export const repeatOrderSchoolFailure = () =>
  action(OrdersSchoolTypes.CHARGE_REQUEST_REPEAT_ORDER_SCHOOL_FAILURE);

// Filter Orders
export const filterOrdersSchoolRequest = (payload: object) =>
  action(OrdersSchoolTypes.FILTER_ORDER_SCHOOL_REQUEST, payload);
export const filterOrdersSchoolSuccess = (payload: {
  chargeRequestSchoolList: ChargeRequestInterface[];
}) => action(OrdersSchoolTypes.FILTER_ORDER_SCHOOL_SUCCESS, payload);
export const filterOrdersSchoolFailure = () =>
  action(OrdersSchoolTypes.FILTER_ORDER_SCHOOL_FAILURE);

// Delete Order
export const deleteChargeRequestSchoolRequest = (payload: object) =>
  action(OrdersSchoolTypes.DELETE_CHARGE_REQUEST_SCHOOL_REQUEST, payload);
export const deleteChargeRequestSchoolSuccess = () =>
  action(OrdersSchoolTypes.DELETE_CHARGE_REQUEST_SCHOOL_SUCCESS);
export const deleteChargeRequestSchoolFailure = () =>
  action(OrdersSchoolTypes.DELETE_CHARGE_REQUEST_SCHOOL_FAILURE);
